<template>
    <div class="ModalHeader">
        <h3 class="ModalHeader__heading"><slot></slot></h3>
        <button-cta type="button" theme="none" class="ModalHeader__close" data-dismiss="modal" aria-label="Close" :onClick="closeModal">×</button-cta>
    </div>
</template>

<script>
import ButtonCta from '@/components/Button/button'

export default {
  name: 'ModalHeader',
  components: {
    ButtonCta
  },
  props: {
    closeModal: Function
  }
}
</script>

<style lang="scss">
    .ModalHeader {
       display: flex;
       justify-content: space-between;
       background-color: #f7f7f7;
       border-bottom: 1px solid #e5e5e5;
       padding: 0 15px;
       &__heading {
         margin: 0;
         height: 60px;
         display: flex;
         align-items: center;
       }
       &__close {
           padding: 0;
           color: #000;
           cursor: pointer;
           background: transparent;
           border: 0;
           opacity: .2;
           font-size: 21px;
           filter: alpha(opacity=20);
           &:hover, &:focus {
                background: transparent;
                color: #000;
                text-decoration: none;
                cursor: pointer;
                opacity: .5;
                filter: alpha(opacity=50);
           }
       }
    }
</style>



// WEBPACK FOOTER //
// src/components/Modal/modal-header.vue